export default "__VITE_ASSET__5MlnXHKk__"